
import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqs = [
    {
      question: 'What do you need from me?',
      answer: 'Nothing to start. We review your public online presence—your website, Google Business Profile, and visible content. No logins, no access required. We\'ll reach out if we need anything specific.'
    },
    {
      question: 'What kind of businesses is this for?',
      answer: 'UK service businesses: trades, salons, home improvement, professional services, and any business that wants to attract better clients. If you\'re tired of low-margin work and want to be more selective, this is for you.'
    },
    {
      question: 'What happens after the free review?',
      answer: 'We\'ll walk you through our findings in a clear, jargon-free report. You\'ll see exactly what\'s working and what\'s not. There\'s no obligation—if you want ongoing support, we can discuss monthly insights. If not, you keep the review and the action plan.'
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="bg-white py-24">
      <div className="max-w-[800px] mx-auto px-6">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-[#FF6B35]/5 border border-[#FF6B35]/20 rounded-full text-sm mb-6">
            <span className="w-1.5 h-1.5 bg-[#FF6B35] rounded-full"></span>
            <span className="text-[#1A1F36] font-medium">FAQ</span>
          </div>
          <h2 className="text-4xl lg:text-[36px] font-bold text-[#1A1F36]">
            Common <span className="text-[#FF6B35]">Questions</span>
          </h2>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className={`bg-[#FAFBFC] rounded-2xl overflow-hidden transition-all duration-300 ${
                openIndex === index ? 'ring-2 ring-[#FF6B35]/20' : 'hover:bg-[#F5F6F8]'
              }`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left cursor-pointer"
              >
                <span className="text-lg font-semibold text-[#1A1F36] pr-4">
                  {faq.question}
                </span>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                  openIndex === index ? 'bg-[#FF6B35] text-white' : 'bg-white text-[#1A1F36]'
                }`}>
                  <i className={`ri-arrow-down-s-line text-xl transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6 pt-0">
                  <p className="text-base text-gray-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
